import React from "react";
import { motion } from "framer-motion";
import {
  FaEnvelope,
  FaLinkedin,
  FaGithub,
  FaTwitter,
  FaMapMarkerAlt,
  FaGlobe,
} from "react-icons/fa";

const ContactInfo = () => {
  const contactDetails = [
    {
      icon: <FaEnvelope className="text-2xl" />,
      label: "Email",
      value: "hello@mihirshah.tech",
      link: "mailto:hello@mihirshah.tech",
      color: "text-blue-400",
      hoverColor: "hover:text-blue-300",
    },
    {
      icon: <FaLinkedin className="text-2xl" />,
      label: "LinkedIn",
      value: "linkedin.com/in/mihirshah99",
      link: "https://linkedin.com/in/mihir-shah99",
      color: "text-blue-500",
      hoverColor: "hover:text-blue-400",
    },
    {
      icon: <FaGithub className="text-2xl" />,
      label: "GitHub",
      value: "github.com/mihir-shah99",
      link: "https://github.com/mihir-shah99",
      color: "text-purple-400",
      hoverColor: "hover:text-purple-300",
    },
    {
      icon: <FaTwitter className="text-2xl" />,
      label: "Twitter",
      value: "@mihirshah99",
      link: "https://x.com/mihirshah99",
      color: "text-cyan-400",
      hoverColor: "hover:text-cyan-300",
    },
    {
      icon: <FaGlobe className="text-2xl" />,
      label: "VXDF Project",
      value: "vxdf.org",
      link: "https://vxdf.org",
      color: "text-green-400",
      hoverColor: "hover:text-green-300",
    },
    {
      icon: <FaMapMarkerAlt className="text-2xl" />,
      label: "Location",
      value: "United States",
      color: "text-red-400",
      hoverColor: "hover:text-red-300",
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl p-8 shadow-2xl h-full"
    >
      <h2 className="text-3xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
        Connect With Me
      </h2>

      <p className="text-gray-300 mb-8">
        Feel free to reach out through any of these channels. I'm always open to
        discussing new opportunities, collaborations, or just having a chat
        about security and technology.
      </p>

      <div className="space-y-6">
        {contactDetails.map((detail, index) => (
          <motion.div
            key={detail.label}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="group"
          >
            {detail.link ? (
              <a
                href={detail.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 p-4 bg-white/5 rounded-lg border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all duration-300 group"
              >
                <div
                  className={`${detail.color} ${detail.hoverColor} transition-colors`}
                >
                  {detail.icon}
                </div>
                <div className="flex-1">
                  <p className="text-sm text-gray-400">{detail.label}</p>
                  <p className="text-white group-hover:text-blue-400 transition-colors">
                    {detail.value}
                  </p>
                </div>
                <div className="text-gray-500 group-hover:text-white transition-colors">
                  →
                </div>
              </a>
            ) : (
              <div className="flex items-center gap-4 p-4 bg-white/5 rounded-lg border border-white/10">
                <div className={detail.color}>{detail.icon}</div>
                <div>
                  <p className="text-sm text-gray-400">{detail.label}</p>
                  <p className="text-white">{detail.value}</p>
                </div>
              </div>
            )}
          </motion.div>
        ))}
      </div>

      {/* Additional Info */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7 }}
        className="mt-8 p-6 bg-gradient-to-br from-blue-500/10 to-purple-500/10 rounded-lg border border-white/10"
      >
        <h3 className="text-lg font-semibold text-white mb-2">Response Time</h3>
        <p className="text-gray-300 text-sm">
          I typically respond within 24-48 hours. For urgent matters related to
          VXDF or security issues, please mention it in your message.
        </p>
      </motion.div>
    </motion.div>
  );
};

export default ContactInfo;
